import {
  Button,
  Card,
  CardActions,
  CardContent,
  Fade,
  Grid,
  Modal,
} from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { updateProject } from '../../../actions/projectActions'
import {
  PROJECT_CURRENT_STEP,
  PROJECT_UPDATE_RESET,
} from '../../../constants/projectConstants'
import { useInput } from '../../../hooks/useInput'
import { Context } from '../../../providers/ProjectContextProvider'
import FormContainer from '../../Form/FormContainer'
import TextAreaInput from '../../Form/TextAreaInput'
import TextInput from '../../Form/TextInput'

const StyledSection = styled.section`
  h3 {
    margin-bottom: 30px;
  }

  .MuiCard-root {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    padding-top: 75%;
    height: 515px;
    display: flex;
  }

  .MuiCardContent-root {
    background-color: rgba(0, 65, 92, 0.9);
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h4 {
      margin-bottom: 15px;
    }

    p {
      margin-bottom: 30px;
    }
  }

  .MuiCardActions-root {
    padding: 0;
  }
`

const ProjectInfo = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { setShowNotifyUser } = useContext(Context)

  const [saveAndGoToDashboard, setSaveAndGoToDashboard] = useState(false)
  const {
    value: name,
    bind: bindName,
    error: nameError,
    setError: setNameError,
    setValue: setName,
  } = useInput('')
  const {
    value: description,
    bind: bindDescription,
    setValue: setDescription,
  } = useInput('')
  const [type, setType] = useState('')
  const [showProgramModal, setShowProgramModal] = useState(false)
  const [stayOnPage, setStayOnPage] = useState(false)

  const { error, project } = useSelector((state: RootStateOrAny) => state.projectDetails)
  const { success: createSuccess } = useSelector((state: RootStateOrAny) => state.projectCreate)
  const { loading: loadingUpdate, success: successUpdate } = useSelector(
    (state: RootStateOrAny) => state.projectUpdate
  )
  const { userInfo } = useSelector((state: RootStateOrAny) => state.userLogin)

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: PROJECT_UPDATE_RESET })

      if (stayOnPage) {
        setStayOnPage(false)
      } else {
        if (saveAndGoToDashboard) {
          history.push('/myquality/dashboard')
        } else {
          dispatch({
            type: PROJECT_CURRENT_STEP,
            payload: 2,
          })
        }
      }
    }
    if (project) {
      setName(project.name)
      setDescription(project.description)
      setType(project.type)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    project,
    dispatch,
    successUpdate,
    saveAndGoToDashboard,
    createSuccess,
    setName,
    setDescription,
    history,
  ])

  const handleSaveAndExit = () => {
    if (userInfo.isAdmin) {
      setStayOnPage(true)
      setShowNotifyUser(true)
      updateProjectHandler()
    } else {
      setSaveAndGoToDashboard(true)
      updateProjectHandler()
    }
  }

  const handleClose = () => {
    setShowProgramModal(false)
  }

  const updateProjectHandler = () => {
    if (formIsReady()) {
      let projectClone = project

      projectClone.name = name
      projectClone.description = description
      projectClone.type = type

      dispatch(updateProject(projectClone))
    }
  }

  const formIsReady = () => {
    let ready = true

    if (name === '') {
      ready = false
      setNameError('Please enter a project name.')
    } else {
      setNameError('')
    }

    return ready
  }

  return (
    <StyledSection>
      <FormContainer>
        <h4 className="m-b-30">Select service</h4>

        <Grid
          container
          spacing={3}
          className="services project-type-selector p-l-40 p-r-40"
        >
          <Grid item md={6} sm={6}>
            <div
              className={`card-wrapper ${
                type === 'programming'
                  ? 'selected'
                  : type !== '' && 'not-selected'
              }`}
              style={{ cursor: 'not-allowed' }}
            >
              <Card
                style={{
                  backgroundImage:
                    'url(/images/homepage/services/contract-programming.jpg)',
                }}
              >
                <CardContent>
                  <div className="content">
                    <h4>Programming services</h4>
                    <p>
                      Getting expert assistance when you need it is vital to
                      maintaining manufacturing productivity. Whether you need
                      new CMM programs created for a new launch or have your
                      existing CMM programs optimized (cycle time, performance,
                      etc.) when production increases, a quote and program are
                      only a few short steps away.
                    </p>
                  </div>
                  <CardActions>
                    <Button
                      className={`btn-white ${
                        type === 'programming' && 'selected'
                      }`}
                      disabled={true}
                    >
                      {type === 'programming' ? 'Selected' : 'Select'}
                    </Button>
                  </CardActions>
                </CardContent>
              </Card>
            </div>
          </Grid>
          <Grid item md={6} sm={6}>
            <div
              className={`card-wrapper ${
                type === 'inspection'
                  ? 'selected'
                  : type !== '' && 'not-selected'
              }`}
              style={{ cursor: 'not-allowed' }}
            >
              <Card
                style={{
                  backgroundImage:
                    'url(/images/homepage/services/contract-inspection.jpg)',
                }}
              >
                <CardContent>
                  <div className="content">
                    <h4>Inspection services</h4>
                    <p>
                      You might be down a system, have too much work, or you
                      just plain need somebody to do the work for you. We are
                      here to run full inspection services at one of our fully
                      staffed centers. We can provide an inspection report to
                      optimizing a program to meet desired cycle time or GR&R
                      criteria. A quote is only a few steps away.
                    </p>
                  </div>
                  <CardActions>
                    <Button
                      className={`btn-white ${
                        type === 'inspection' && 'selected'
                      }`}
                      disabled={true}
                    >
                      {type === 'inspection' ? 'Selected' : 'Select'}
                    </Button>
                  </CardActions>
                </CardContent>
              </Card>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput
              name="name"
              label="Project name"
              bindValue={bindName}
              error={nameError}
            />
          </Grid>

          <Grid item xs={12}>
            <TextAreaInput
              name="description"
              label="Project description (optional)"
              bindValue={bindDescription}
              rows={4}
            />
          </Grid>
        </Grid>
        <div className="actions m-t-40">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveAndExit}
            disabled={loadingUpdate}
            className={loadingUpdate ? 'loading' : ''}
          >
            Save and exit
          </Button>

          <div>
            <Link to="/myquality/dashboard">
              <Button
                variant="outlined"
                color="primary"
                disabled={loadingUpdate}
                className={loadingUpdate ? 'loading' : ''}
              >
                Cancel
              </Button>
            </Link>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 20 }}
              onClick={updateProjectHandler}
              disabled={loadingUpdate}
              className={loadingUpdate ? 'loading' : ''}
            >
              Next
            </Button>
          </div>
        </div>
        {error && error}
      </FormContainer>

      <Modal
        open={showProgramModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Fade in={showProgramModal}>
          <div className="modal-window"> Modal </div>
        </Fade>
      </Modal>
    </StyledSection>
  )
}

export default ProjectInfo
